<template>
  <div>
    <section class="section" style="padding-top: 0.5rem">
      <div class="container">
        <div class="columns">
          <div class="column is-8 is-offset-2">
            <horizontal-stepper
              :steps="demoSteps"
              @completed-step="completeStep"
              :top-buttons="true"
              @active-step="isStepActive"
              @stepper-finished="finish"
              locale="pt"
            ></horizontal-stepper>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import HorizontalStepper from "vue-stepper";
import Swal from "sweetalert2";
import StepOne from "@/components/ContractStepper/StepOne.vue";
import StepTwo from "@/components/ContractStepper/StepTwo.vue";
import StepThree from "@/components/ContractStepper/StepThree.vue";
export default {
  name: "home",
  components: {
    HorizontalStepper
  },
  data() {
    return {
      demoSteps: [
        {
          icon: "search",
          name: "first",
          title: "Primeiro Passo",
          subtitle: "Buscar Cliente",
          component: StepOne,
          completed: false
        },
        {
          icon: "category",
          name: "second",
          title: "Segundo Passo",
          subtitle: "Escolher Ponto",
          component: StepTwo,
          completed: false
        },
        {
          icon: "receipt",
          name: "last",
          title: "Último Passo",
          subtitle: "Gerar Contrato",
          component: StepThree,
          completed: false
        }
      ],
      activeStep: 0
    };
  },
  computed: {
    userName() {
      return this.$store.getters.userName;
    },
    client() {
      return this.$store.getters.client;
    },
    points() {
      return this.$store.getters.points;
    },
    newClient() {
      return this.$store.getters.newClient;
    },
    loyalty() {
      return this.$store.getters.loyalty;
    }
  },
  methods: {
    ...mapActions(["logout", "createContract"]),
    completeStep(payload) {
      this.demoSteps.forEach(step => {
        if (step.name === payload.name) {
          step.completed = true;
        }
      });
    },
    isStepActive(payload) {
      this.demoSteps.forEach(step => {
        if (step.name === payload.name) {
          if (step.completed === true) {
            step.completed = false;
          }
        }
      });
    },
    async finish(payload) {
      if (
        this.client == null ||
        this.points.length === 0 ||
        this.newClient == null
      ) {
        await Swal.fire(
          "Ops!",
          "Não foi possível gerar o contrato, verifique se todos os passos estão corretos.",
          "error"
        );
        return;
      }

      const result = await Swal.fire({
        title: "Atenção!",
        text: `Deseja realmente criar este contrato para ${this.client.name}?`,
        icon: "warning",
        focusConfirm: false,
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonColor: "#9dcf6b",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim",
        cancelButtonText: "Não"
      });

      if (!result.isConfirmed) {
        return;
      }

      try {
        Swal.fire({
          title: "Criando",
          html: "Criando contrato(s)...",
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });

        const contractsToCreate = [];

        for (const point of this.points) {
          if (point.plan.groupId == 29) {
            contractsToCreate.push(this.createContract({
              name: "Termo de Adesão (TV)",
              fileName: "termo-de-adesao-tv",
              revision: "0",
              clientId: this.client.id,
              pointId: point.id,
              isNew: this.newClient
            }));
          } else {
            contractsToCreate.push(this.createContract({
              name: "Termo de Adesão",
              fileName: "termo-de-adesao",
              revision: "1",
              clientId: this.client.id,
              pointId: point.id,
              isNew: this.newClient
            }));
          }

          if (this.loyalty) {
            contractsToCreate.push(this.createContract({
              name: "Permanência mínima",
              fileName: "permanencia-minima",
              revision: "0",
              clientId: this.client.id,
              pointId: point.id,
              isNew: this.newClient
            }));
          }
        }

        await Promise.all(contractsToCreate);

        Swal.close();
        await Swal.fire(
          "Sucesso!",
          "Contrato gerado para o cliente.",
          "success"
        );

        location.reload();
      } catch (e) {
        await Swal.fire(
          "Ops!",
          "Não foi possível criar o contrato, verifique os campos e tente novamente.",
          "error"
        );
      }
    },
    exit() {
      this.logout();
      this.$router.push("/login");
    }
  }
};
</script>

<style scoped>
</style>
